__turbopack_context__.v({
  "fieldset": "newsletter-form-module__S9KG4q__fieldset",
  "nf-pop-in": "newsletter-form-module__S9KG4q__nf-pop-in",
  "toast": "newsletter-form-module__S9KG4q__toast",
  "toastClose": "newsletter-form-module__S9KG4q__toastClose",
  "toastError": "newsletter-form-module__S9KG4q__toastError",
  "toastIcon": "newsletter-form-module__S9KG4q__toastIcon",
  "toastLane": "newsletter-form-module__S9KG4q__toastLane",
  "toastMessage": "newsletter-form-module__S9KG4q__toastMessage",
  "toastSuccess": "newsletter-form-module__S9KG4q__toastSuccess",
  "wrap": "newsletter-form-module__S9KG4q__wrap",
});
